import { Outlet } from 'react-router-dom';
import AppHeader from '../components/common/AppHeader';

export default function ProviderLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="pt-16">
        <Outlet />
      </main>
    </div>
  );
}